"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var Context_1 = require("../../../Context");
require("../Styles/DashboardInfoBar.css");
require("../Styles/DashboardInfoBar.scss");
var react_fontawesome_1 = require("@fortawesome/react-fontawesome");
var free_solid_svg_icons_1 = require("@fortawesome/free-solid-svg-icons");
var EventHandlerService_1 = require("../../../Services/EventHandlerService");
var Types_1 = require("../Types");
var DashboardInfoBar = /** @class */ (function (_super) {
    __extends(DashboardInfoBar, _super);
    function DashboardInfoBar(props) {
        return _super.call(this, props) || this;
    }
    DashboardInfoBar.prototype.render = function () {
        var _this = this;
        return (React.createElement(Context_1.AuthConsumer, null, function (auth) { return auth && (React.createElement("div", { className: "row mb-2 dashboard-info-bar" },
            React.createElement("div", { className: "col text-muted" }, _this.props.resources.ChooseAction),
            React.createElement("div", { className: "col-md-auto pr-1 text-muted" },
                _this.props.resources.UserInfo_Organisation,
                " "),
            React.createElement("div", { className: "col-md-auto pl-1 text-primary font-weight-bold text-uppercase" }, auth.getUser().Organisation),
            React.createElement("div", { className: "col-md-auto pr-1 text-muted" },
                _this.props.resources.Location,
                ": "),
            React.createElement(Context_1.GlobalConsumer, null, function (context) { return context && (React.createElement("div", { className: "col-md-auto pl-1 " },
                React.createElement("span", { className: "text-primary font-weight-bold text-uppercase mr-2" }, context.selectedLocation),
                React.createElement("span", { className: "text-secondary icon-hover", onClick: function () {
                        EventHandlerService_1.EventHandlerProvider.GetInstance().AddEvent(Types_1.ChangeLocationEvent(context));
                    } },
                    React.createElement(react_fontawesome_1.FontAwesomeIcon, { className: "small ", icon: free_solid_svg_icons_1.faExchangeAlt })))); }))); }));
    };
    return DashboardInfoBar;
}(React.Component));
exports.DashboardInfoBar = DashboardInfoBar;
//# sourceMappingURL=DashboardInfoBar.js.map